module.exports = "<footer class=\"app-footer text-light bg-dark\">\r\n  <span class=\"ml-auto text-light bg-dark\">© 2018 Copyright <a href=\"http://www.aaa-system.co.jp/\">AAA System Co., Ltd.</a></span>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main